module.exports = __webpack_public_path__ + "static/media/documentdark.e3e71a5c.svg";